import React, { useMemo } from 'react'
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {RootState} from "../../Redux";
import {get} from "lodash";
import {Typography} from "@mui/material";
import {AccordionItem} from "./AccordionItem";
import {makeStyles} from "tss-react/mui";
import {Theme} from "@mui/material/styles";

const useStyles = makeStyles()((theme: Theme) => ({
    accordionContent: {
        flex: 1,
    },
    text: {
        fontSize: theme.typography.pxToRem(14),
    },
}))

export default function UserInfo() {
    const { t } = useTranslation()
    const { classes } = useStyles()

    const checkIn = useSelector((state: RootState) => state.checkIn);

    const customerInfo = useMemo(
        () => checkIn.checkIn?.sale?.customer,
        [checkIn.checkIn?.sale?.customer]
    );

    const vehicleInfo = useMemo(
        () => get(checkIn, 'checkIn.sale.tasks[0].vehicle'),
        [checkIn]
    );

    const renderUserInfo = () => (
        <div className={classes.accordionContent}>
            <Typography className={classes.text}>
                {customerInfo?.phone}
            </Typography>
            <Typography className={classes.text}>
                {vehicleInfo?.registrationNumber}
            </Typography>
            <Typography className={classes.text}>
                {customerInfo?.email}
            </Typography>
            <Typography className={classes.text}>
                {customerInfo?.primaryAddress?.line1}
            </Typography>
            {customerInfo?.primaryAddress && (
                <Typography className={classes.text}>
                    {customerInfo.primaryAddress.zipCode}{' '}
                    {customerInfo.primaryAddress.city}
                </Typography>
            )}
        </div>
    )

    return (
        <AccordionItem
            heading={t('common.customer')}
            subHeading={customerInfo?.name}
            content={renderUserInfo()}
        />
    );
}
